import { PublicClientApplication } from "@azure/msal-browser";
import { getTokenAsync as getTokenAsyncAuth0, logout as logoutAuth0 } from "./auth0";
import AuthenticationCompontentAuth0 from "./auth0/AuthenticationComponent";
import { getTokenAsync as getTokenAsyncMsal, logout as logoutMsal, msalConfig } from "./msalAuth";
import AuthenticationCompontentMsal from "./msalAuth/AuthenticationCompontent";
import { getTokenAsync as getTokenAsyncOpenId, logout as logoutOpenId } from "./openid";
import AuthenticationCompontentOpenId from "./openid/AuthenticationCompontent";
import { getAuthProvider } from "./runtimeConfig";
import { withFontLoading } from "./withFontLoading";

type EnhancedComp = (
  props: {
    children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>;
  } & object & {
      children?: React.ReactNode;
    }
) => JSX.Element;

// Wrap both authentication components with font loading capability
const EnhancedAuthenticationCompontentOpenId = withFontLoading(AuthenticationCompontentOpenId);
const EnhancedAuthenticationCompontentMsal = withFontLoading(AuthenticationCompontentMsal);
const EnhancedAuthenticationCompontentAuth0 = withFontLoading(AuthenticationCompontentAuth0);

const getAuthProviderType = () => {
  try {
    return getAuthProvider();
  } catch {
    if (import.meta.env.VITE_USEAUTH0 === "true") {
      return "auth0";
    }
    return typeof import.meta.env.VITE_OPENID_AUTHORITY !== "undefined" && import.meta.env.VITE_USEMSAL == undefined
      ? "openid"
      : "msal";
  }
};

const authProvider = getAuthProviderType();

let AuthComp: EnhancedComp = EnhancedAuthenticationCompontentMsal;
let getTokenAsync: () => Promise<string | undefined | void> = () => Promise.resolve("");
let logout = () => Promise.resolve();
switch (authProvider) {
  case "auth0":
    AuthComp = EnhancedAuthenticationCompontentAuth0;
    getTokenAsync = getTokenAsyncAuth0;
    logout = logoutAuth0;
    break;
  case "openid":
    AuthComp = EnhancedAuthenticationCompontentOpenId;
    getTokenAsync = getTokenAsyncOpenId;
    logout = logoutOpenId;
    break;
  default:
    AuthComp = EnhancedAuthenticationCompontentMsal;
    getTokenAsync = getTokenAsyncMsal;
    logout = logoutMsal;
    break;
}

export const msalInstance = new PublicClientApplication(msalConfig);

export { getTokenAsync, logout };
export const AuthenticationCompontent = AuthComp;

export const getMsalUser = () => msalInstance.getAllAccounts()[0];
export const getUserName = () => msalInstance.getAllAccounts()[0]?.name ?? "";
export const getInitials = () => {
  const name = getUserName();
  const names = name.split(" ");
  const initials = names.map((n) => n.substring(0, 1).toUpperCase()).join("");
  return initials;
};
export const getPasswortResetUrl = () => {
  return `${import.meta.env.VITE_RESET_PASSWORD_URI}`;
};
